import PropTypes from 'prop-types';

import { basicMastheadType } from 'humanity/sections/basicMasthead/basicMasthead.types';
import { ctaBannerType } from 'humanity/sections/ctaBanner/ctaBanner.types';
import { lcRelatedArticlesType } from 'humanity/sections/lcRelatedArticles';

export const retirementGlossaryTermProps = {
  title: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.oneOfType([basicMastheadType, ctaBannerType, lcRelatedArticlesType])
  ).isRequired,
};

export const retirementGlossaryTermType = PropTypes.shape({
  ...retirementGlossaryTermProps,
});
